<template>
  <div id="GoTop" @click="GoTop()">
    <!-- <span class="glyphicon glyphicon-chevron-up"></span> -->
    <!-- 修改样式 -->
	<div class = "t1">
		<!-- <div class = "s1">
			<el-popover placement="right" width="120" trigger="hover">
				<div slot="reference">
					<div class = "a1">
						<i class="el-icon-service"></i>
					</div>
					<div class = "a2">在线咨询</div>
				</div>
				<div>
					<div style = "cursor: pointer;border-bottom: 1px solid #ececec;padding: 0 0 10px 0;display: flex;flex-direction: row;">
						<div style = "margin:2px 5px 0px 0">
							<img src = "@/assets/img/foot_img1.png"/>
						</div>
						<div>在线咨询</div>
					</div>
					<div style = "cursor: pointer;padding: 10px 0 px 0;display: flex;flex-direction: row;margin:10px 0 0 0">
						<div style = "margin:2px 5px 0px 0">
							<img src = "@/assets/img/foot_img_2.png"/>
						</div>
						<div>售前咨询专员</div>
					</div>
				</div>
			</el-popover>
		</div> -->
		<div class = "s1">
			<el-popover placement="right" width="250" trigger="hover">
				<div slot="reference">
					<div class = "a1">
						<i class="el-icon-phone-outline"></i>
					</div>
					<div class = "a2">免费电话</div>
				</div>
				<div>
					<div style = "border-bottom: 1px solid #ececec;padding: 0 0 5px 0;">免费通话</div>
					<div style = "color:#A2A2A2;padding: 5px 0 5px 0;">24小时免费咨询</div>
					<div style = "color:#A2A2A2;padding: 0px 0 10px 0;">请输入您的联系电话，座机请加区号</div>
					<div>
						<el-input v-model="phone" placeholder="请输入您的电话号码" :maxlength = "11"></el-input>
					</div>
					<div style = "margin:10px 0 0 0">
						<el-button type="success" style = "width:100%;" @click="postData">免费通话</el-button>
					</div>
				</div>
			</el-popover>
		</div>
		<div class = "s1">
			<div class = "a1">
				<i class="el-icon-position"></i>
			</div>
			<div class = "a2">回到顶部</div>
		</div>
	</div>
  </div>
</template>
<script>
import { api_home_postPhone} from '@/api/home';
import { Message } from 'element-ui';
import {getGLocData,getLocData,merge,reg,getAuthList,getImageUrl,formatDate,escape2Html,checkPhone} from '@/utils/index';
export default {
  name: "GoTop",
  data() {
    return {
	  flag: false,
	  phone:"",
	  postLoading:0,
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
	},
	//提交电话
	postData(){
		var version = 1;
		if(this.$route.query.version){
            version = this.$route.query.version
		}
		console.log("version:"+version);
		//判读手机号
		if(!checkPhone(this.phone)){
			Message({showClose: true,message:"请输入正确的手机号码",type:'error'});return;
		}
		if(1){
			var params = new Object();
			params['tel'] = this.phone;
			if(this.postLoading == 1){
				return;
			}
			this.postLoading = 1;
            api_home_postPhone(params).then(rdata => {
                console.log(rdata);
				var rb = rdata.data;
				this.postLoading = 0;
                if(rb.code == 200){
					//15972046069
					//var result = rb['data'];
					Message({showClose: true,message:"提交完成",type:'success'});return;
                }
            });
		}
	},
  }
};
</script>
<style scoped>
#GoTop {
  width: 72px;
  position: fixed;
  right: 20px;
  bottom: 200px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}

#GoTop .t1{
	background: #2C313B;
	color: #ffffff;
}
#GoTop .t1 .s1{
	text-align: center;
	height: 72px;
}
#GoTop .t1 .s1 .a1{font-size: 20px;padding: 10px 0 0px 0;}
#GoTop .t1 .s1 .a2{}
#GoTop .t1 .s1 .a3{}
#GoTop .t1 .s1:hover{
	background: #85C82B;
	color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue